// extracted by mini-css-extract-plugin
export default {"primaryColor":"#808d99","primaryColorDark":"#8c46ff","secondaryColor":"#8c46ff","secondaryColorLight":"rgba(140,70,255,.3)"};